<style>
@import '../../assets/css/account.css';
</style>

<template>
    <div class="main-panel">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t('button.search')" header-tag="header" class="mb-3">
                    <form @submit.prevent="initialize" :submit="initialize">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_username')}}</template>
                            <el-input v-model="ajaxSearch.login" clearable></el-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label"></template>
                            <b-button variant="primary" type="submit">{{$t('button.search')}}</b-button>
                        </b-form-group>
                    </form>
                </b-card>
                <b-card :header="$t($route.name)">
                    <b-button variant="primary" class="mb-3 float-right" v-b-modal.addSpecial v-if="permissionList.includes(permission.add)"><font-awesome-icon icon="plus"/> {{$t('account_special.table_add')}}</b-button>
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand">
                            <b-button variant="primary" size="lg" @click="getEditSpecial()" v-if="permissionList.includes(permission.edit)" class="ml-1">{{$t('account_special.table_edit')}}</b-button>                  
                            <b-button variant="danger" size="lg" class="ml-1" @click="deleteSpecial()" v-if="permissionList.includes(permission.delete)">{{$t('account_special.table_delete')}}</b-button>
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>

                <b-modal id="addSpecial" :title="$t('account_special.table_add')" @ok="addSpecial" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="addSpecialForm" @submit.prevent="addSpecial()">
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_username')}}</template>
                            <b-form-input name="login"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_value')}}</template>
                            <b-form-input name="value" v-model="ajaxAdd.value"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_status')}}</template>
                            <b-form-checkbox name="status" v-model="ajaxAdd.status" size="lg" value="1" unchecked-value="0" switch></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_special')}}</template>
                            <b-form-select name="status_id">
                                <option v-for="(list,index) in statusList" :key="index" :value='list.id'>{{list.name}}</option>
                            </b-form-select>
                        </b-form-group>
                    </form>
                </b-modal>

                <b-modal id="editSpecial" :title="$t('account_special.table_edit')" @ok="editSpecial" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="editSpecialForm" @submit.prevent="addSpecial()">
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_username')}}</template>
                            <label class="from-label">{{ajaxEdit.login}}</label>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_special')}}</template>
                            <label class="from-label">{{ajaxEdit.name}}</label>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_status')}}</template>
                            <b-form-checkbox name="status" v-model="ajaxEdit.status" size="lg" value="1" unchecked-value="0" switch></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_value')}}</template>
                            <b-form-input name="value" v-model="ajaxEdit.value"></b-form-input>
                        </b-form-group>
                    </form>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import {specialAjaxTable,specialSearch,specialAdd,getSpecialEdit,specialEdit,specialDelete} from '@/system/model/account'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';
export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            ajaxTable:[],
            ajaxTool:[],
            ajaxSearch:{limit:'',pagination:'',id:'',login:'',status_id:'',created_at:''},
            ajaxAdd:{status:1,value:0},
            ajaxRow:'',
            ajaxInfo:[],
            ajaxEdit:[],
            statusList:[],
            tabIndex:1,
            pageLimit:10,
            permission:{
                add: '4033E9',
                edit:'9999F9',
                delete:'23015C'
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width:'100'
            },{
                prop: "login",
                label: this.$t('admin.table_username'),
                width:'200'
            },{
                prop: "status_id",
                label: this.$t('admin.table_special'),
                width:'300'
            },{
                prop: "value",
                label: this.$t('admin.table_value'),
                width:'150'       
            },{
                prop: "status",
                label: this.$t('admin.table_status'),
                width:'100'
            },{
                prop: "created_at",
                label: this.$t('admin.table_date'),
                width:'200'                              
            }],        
        }
    },methods:{
        initialize(){
            var self = this;
            var result = specialAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.login,this.ajaxSearch.status_id,this.ajaxSearch.created_at);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.statusList = value.data.status_list;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },addSpecial(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                var form = document.getElementById('addSpecialForm');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                var result = specialAdd(formData);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.initialize();
                                self.$bvModal.hide('addSpecial');
                            }
                        });
                    }else{
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();
                                self.$bvModal.hide('addSpecial');
                            }
                        });
                    }
                });
            }
        },getEditSpecial(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                var result = getSpecialEdit(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    self.$bvModal.show('editSpecial');
                    if(value.valid){
                        self.ajaxEdit = value.data;
                    }
                });
            }
        },editSpecial(){
            var self = this;
            var form = document.getElementById('editSpecialForm');
            var formData = new FormData(form);
            formData.append(this.csrfNameKey, this.csrfName); 
            formData.append(this.csrfValueKey, this.csrfValue); 
            formData.append('id', this.ajaxEdit.id); 
            var result = specialEdit(formData);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.$swal.fire({
                        type: 'success',
                        text: self.$t(value.returnMsg),
                        onClose: () => {
                            self.initialize();
                            self.$bvModal.hide('editSpecial');
                        }
                    });
                }else{
                    var text = "";
                    if(Array.isArray(value.returnMsg)){
                        value.returnMsg.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                    }else{
                        text = self.$t(value.returnMsg);
                    }

                    self.$swal.fire({
                        type: 'error',
                        html: text,
                        onClose: () => {
                            self.initialize();
                            self.$bvModal.hide('editSpecial');
                        }
                    });
                }
            });
        },deleteSpecial(){
            if(this.permissionList.includes(this.permission.delete)){
                this.$swal.fire({
                text: this.$t('msg.confirm_delete'),
                type: 'info',
                showCancelButton: true,
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        self.preloader(true);
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('id', this.ajaxRow); 
                        var result = specialDelete(formData);		
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }else{
                                self.preloader(false);
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
